/**
 * `components.MuiCardHeader` & `components.MuiCardContent` — card section padding.
 * Discoverability: `MuiCardHeader`, `MuiCardContent`, `Card`, `CardHeader`.
 *
 * @see https://mui.com/material-ui/api/card-header/
 * @see https://mui.com/material-ui/api/card-content/
 *
 */
import type { Components, Theme } from '@mui/material/styles';

export function muiCard(theme: Theme): Pick<Components<Theme>, 'MuiCardHeader' | 'MuiCardContent'> {
  return {
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
          '&:last-child': {
            paddingBottom: theme.spacing(2),
          },
        },
      },
    },
  };
}
